module.exports = __webpack_public_path__ + "img/vg.47fe9060.svg";